import {useState, useEffect} from 'react';
import { Grid, Button, Typography, Tabs, Tab, Box } from '@mui/material';
import MlmuserInfo from './MlmuserInfo';
import SuccessPayment from './SuccessPayment';
import MembershipTree from 'components/mlmuser/components/MembershipTree';
import MlmcreditPage from 'components/mlmcredit/page/MlmcreditPage';
import PartnerActions from './PartnerActions';

export default function ManagePartnershipActionImpl(){
    const [selectedTab, setSelectedTab] = useState('associate');

    const handleTabChange = (event, newValue) => {
        setSelectedTab(newValue);
    };

    const renderTabContent = () => {
        switch (selectedTab) {
            case 'associate':
                return (
                    <Box sx={{ }}>
                        <PartnerActions />
                    </Box>
                );
            case 'payment':
                return (
                    <Box sx={{p:1 }}>
                        <SuccessPayment />
                    </Box>
                );
            case 'members':
                return (
                    <Box sx={{ 
                        p: 1,
                        width: '90vw',
                        overflowX: 'auto',
                        overflowY: 'auto',
                        maxHeight: '70vh',
                        '&::-webkit-scrollbar': {
                            width: '8px',
                            height: '8px',
                        },
                        '&::-webkit-scrollbar-track': {
                            backgroundColor: 'grey.100',
                            borderRadius: '4px',
                        },
                        '&::-webkit-scrollbar-thumb': {
                            backgroundColor: 'grey.400',
                            borderRadius: '4px',
                            '&:hover': {
                                backgroundColor: 'grey.600',
                            },
                        },
                    }}>
                        <MembershipTree/>
                    </Box>
                );
            case 'credit':
                return (
                    <Box sx={{ }}>
                        <MlmcreditPage />
                    </Box>
                );
            case 'actions':
                return (
                    <Box sx={{ }}>
                        <PartnerActions />
                    </Box>
                );
            default:
                return null;
        }
    };

    return (
        <Grid container>
            <Grid item xs={12}>
                <Box sx={{ 
                    borderBottom: 1, 
                    borderColor: 'divider', 
                    mb: 2,
                    maxWidth: '90vw',
                    overflowX: 'auto',
                    '&::-webkit-scrollbar': {
                        height: '4px',
                    },
                    '&::-webkit-scrollbar-track': {
                        backgroundColor: 'grey.100',
                        borderRadius: '2px',
                    },
                    '&::-webkit-scrollbar-thumb': {
                        backgroundColor: 'grey.400',
                        borderRadius: '2px',
                        '&:hover': {
                            backgroundColor: 'grey.600',
                        },
                    },
                }}>
                    <Tabs 
                        value={selectedTab} 
                        onChange={handleTabChange}
                        sx={{
                            '& .MuiTab-root': {
                                //minWidth: 120,
                                fontWeight: 600,
                                textTransform: 'none',
                            },
                            '& .MuiTabs-indicator': {
                                backgroundColor: 'primary.main',
                            },
                        }}
                    >
                        <Tab 
                            label="Associate" 
                            value="associate"
                            sx={{
                                color: selectedTab === 'associate' ? 'primary.main' : 'text.secondary',
                                '&.Mui-selected': {
                                    color: 'primary.main',
                                }
                            }}
                        />
                        <Tab 
                            label="Payment" 
                            value="payment"
                            sx={{
                                color: selectedTab === 'payment' ? 'primary.main' : 'text.secondary',
                                '&.Mui-selected': {
                                    color: 'primary.main',
                                }
                            }}
                        />
                        <Tab 
                            label="Members" 
                            value="members"
                            sx={{
                                color: selectedTab === 'members' ? 'primary.main' : 'text.secondary',
                                '&.Mui-selected': {
                                    color: 'primary.main',
                                }
                            }}
                        />
                        <Tab 
                            label="Credit" 
                            value="credit"
                            sx={{
                                color: selectedTab === 'credit' ? 'primary.main' : 'text.secondary',
                                '&.Mui-selected': {
                                    color: 'primary.main',
                                }
                            }}
                        />
                        {/* <Tab 
                            label="Actions" 
                            value="actions"
                            sx={{
                                color: selectedTab === 'actions' ? 'primary.main' : 'text.secondary',
                                '&.Mui-selected': {
                                    color: 'primary.main',
                                }
                            }}
                        /> */}
                    </Tabs>
                </Box>
                
                {/* Tab Content */}
                {renderTabContent()}
            </Grid>
        </Grid>
    );
}